<template>
  <Card>
    <p slot="title">
      <Icon type="md-alert"/>
      报表ShortName管理
    </p>
    <template slot="extra">
      <router-link to="/inv/meta" slot="extra">报表Meta管理</router-link> &nbsp; &nbsp;
    </template>
    <Row>
      <Col span="24">
      <Input v-model="query.skuCode" placeholder="sku编码" class="public-inp md5"/>
      <Select v-model="query.year" placeholder="请选择统计年份" class="public-inp md5">
        <Option
          v-for="item in yearList"
          :value="item"
          :key="item"
        >{{item}}
        </Option>
      </Select>
      <Select v-model="query.month" placeholder="请选择统计月份" class="public-inp md5">
        <Option
          v-for="item in monthList"
          :value="item"
          :key="item"
        >{{item}}
        </Option>
      </Select>
      <Button type="primary" icon="md-upload" class="public-fr" @click="add()">新增ShortName
      </Button>
      <!--      <Button type="primary" icon="md-add" class="public-fr" @click="stockImport()">初始化期初|期末库存</Button>-->
      <Button class="public-fr" @click="reset()">重置</Button>
      <Button class="public-fr" type="primary" icon="ios-search" @click="getList()">查询</Button>
      </Col>
      <Col span="24">
      <Table
        :style="{marginTop:'10px'}"
        border
        stripe
        :loading="loading"
        :columns="columns"
        :data="tbList">
        <template slot-scope="{ row,index }" slot="sort">
          <span v-show="false">{{row.code}}</span>
          {{index+1}}
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <a href="javascript:;" @click="editFn(row)">编辑</a>
        </template>
        <template slot-scope="{ row }" slot="status">
          <i-switch
            :value="row.status == 1"
            :before-change="beforeStateChange"
            @on-change="stateChange(row, $event)"
          />
        </template>
      </Table>
      <Page
        :style="{ float: 'right', marginTop: '10px' }"
        :total="total"
        show-sizer
        show-total
        prev-text="上一页"
        next-text="下一页"
        show-elevator
        @on-change="pageNumChange"
        @on-page-size-change="pageSizeChange"
      />
      </Col>
    </Row>
  </Card>
</template>
<script>
  import columns from '@/views/task/columns';

  export default {
    data() {
      return {
        visiable: false,
        open: false,
        query: {
          page: 1,
          rows: 10,
          skuCode: "",
          year: "",
          month: "",
        },
        columns: [{
          title: 'id',
          key: 'id',
          width: 130,
          fixed: 'left'
        }, {
          title: 'category',
          key: 'category',
          width: 160
        }, {
          title: 'shortName',
          key: 'shortName',
          width: 160
        }, {
          title: '状态',
          key: 'status',
          width: 150
        }, {
          title: '备注',
          key: 'remark',
          width: 200
        }, {
          title: '创建时间',
          key: 'createtime',
          width: 160,
        }, {
          title: '更新时间',
          key: 'updatetime',
          width: 160,
          fixed: 'right'
        }],
        tbList: [],
        loading: false,
        total: 0,
        isDisabled: false,
      }
    },
    created() {
      this.getList();
    },
    methods: {
      getList() {
        let data = this.query;
        this.loading = true;
        this.$api.getInvReportShortNameList(data).then(res => {
          this.loading = false;
          if (res.code == '200') {
            this.tbList = res.data;
            this.total = res.total;
          }
        })
      },
      reset() {
        this.query.spCode = "";
        this.query.year = "";
        this.query.month = "";
        this.$nextTick(() => {
          this.getList();
        })
      },
      uploadToggle() {
        this.visiable = !this.visiable
      },
      // 页码
      pageNumChange(pageNum) {
        this.query.page = pageNum;
        this.getList();
      },
      // 页数
      pageSizeChange(pageSize) {
        this.query.rows = pageSize;
        // 页码变动触发pageNumChange
        if (this.query.page == 1) {
          this.getList();
        } else {
          this.query.page = 1;
        }
      },
      add() {
        this.$router.push({
          name: 'shortNameAdd'
        });
      },
    }
  }
</script>
<style scoped>
  .md5 {
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/invreport/shortName.vue